module.exports = require("core-js-pure/stable/instance/last-index-of");